import InfoScreen from "../InfoScreen/LeftScreen/LeftScreen";
import faymLogo from "../../assets/icons/mobileIcons/faymLogo.png";
import styles from "./index.scss";

const index = () => {
    return (
        <div className="parentContainer">
            <div className="infoContainer">
                <div className="header">
                    <img className="faymLogo" alt="faym-logo" src={faymLogo} />
                    <h1> Choose Your Username </h1>
                    <p>Add your Username to Personalize your Experience</p>
                </div>
                <InfoScreen />
            </div>
        </div>
    );
};

export default index;
